/**
 * Dependency-free error-report relay.
 *
 * The app-wide `ErrorBoundary` lives in the static client entry graph and must
 * never pull in `@sentry/react` (whose dev module path contains "sentry" and is
 * matched by adblock / tracking-protection filters). So the boundary calls
 * `reportError` here, and the error-monitoring module registers itself as the
 * reporter only once it has lazily + guardedly loaded. If monitoring never
 * loads (blocked, no DSN), errors simply go unreported, never unhandled.
 */
type Reporter = (error: unknown, info?: unknown) => void;

let reporter: Reporter | null = null;

export function setErrorReporter(r: Reporter) {
  reporter = r;
}

export function reportError(error: unknown, info?: unknown) {
  try {
    reporter?.(error, info);
  } catch {
    /* error reporting must never itself throw */
  }
}
